import { Injectable } from '@angular/core';

declare let gtag: Function;

@Injectable({
  providedIn: 'root'
})
export class GoogleAnalyticsService {

  trackNavigation(pageTitle: string, userName: string): void {
    gtag('event', pageTitle, {
      user: userName,
      datetime: new Date(),
    });
  }


  trackEvent(eventType: string, eventName: string, eventMessage: string): void {
    gtag('event', eventType, {
      Name: eventName,
      Message: eventMessage,
    });
  }

  trackError(errorType: string, errorStatus: string, errorURL: string, errorMessage: string): void {
    gtag('event', 'ERROR', {
      Type: errorType,
      Status: errorStatus,
      Url: errorURL,
      Message: errorMessage,
    });
  }

  setUserId(userId: string) {
    gtag('config', 'G-RNHPWMQT0R', {
      'user_id': userId
    });

    gtag('config', 'G-QRT4PNG3P7', {
      'user_id': userId
    });
  }
}
